module.exports = __webpack_public_path__ + "img/logo.395e7844.png";